import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 mt-20" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "custom-checkbox" }
const _hoisted_7 = { class: "col-md-4 mt-20" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "custom-checkbox" }
const _hoisted_10 = { class: "col-md-4 mt-20" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-4 mt-20" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-4 mb-3" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col-md-4 mb-3" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "col-md-4 mb-3" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "col-md-4 mb-3" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = { class: "col-md-4 mb-3" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_25 = { class: "col-md-4 mb-3" }
const _hoisted_26 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_27 = { class: "col-md-4 mb-3" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = { class: "col-md-4 mb-3" }
const _hoisted_30 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_31 = { class: "col-md-4 mb-3" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = { class: "col-md-4 mb-3" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = {
  key: 0,
  class: "mb-2 d-flex align-items-center gap-2"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "col-md-4 mb-3" }
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = {
  key: 0,
  class: "mb-2 d-flex align-items-center gap-2"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = ["href"]
const _hoisted_43 = { class: "col-md-4 mb-3" }
const _hoisted_44 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_45 = {
  key: 0,
  class: "mb-2 d-flex align-items-center gap-2"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "col-md-4 mb-3" }
const _hoisted_49 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_50 = { class: "col-md-4 mb-3" }
const _hoisted_51 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_52 = { class: "col-md-8 mb-3" }
const _hoisted_53 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_54 = {
  key: 1,
  class: "col-md-12 mb-3"
}
const _hoisted_55 = { class: "col-md-4 mb-3" }
const _hoisted_56 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_57 = { class: "col-md-12 mt-3" }
const _hoisted_58 = { class: "d-flex align-items-center" }
const _hoisted_59 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "societeFormRef",
        onSubmit: _ctx.editSociete,
        "validation-schema": _ctx.societeSchema,
        "initial-values": _ctx.initialValues
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, [
                  _createVNode(_component_Field, {
                    name: "estRegimeTPS",
                    type: "checkbox",
                    value: true,
                    "unchecked-value": false
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("input", _mergeProps({ type: "checkbox" }, field), null, 16)
                    ]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                  _cache[4] || (_cache[4] = _createTextVNode(" Est Régime TPS ? "))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, [
                  _createVNode(_component_Field, {
                    name: "estModeMecef",
                    type: "checkbox",
                    value: true,
                    "unchecked-value": false
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("input", _mergeProps({ type: "checkbox" }, field), null, 16)
                    ]),
                    _: 1
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "checkmark" }, null, -1)),
                  _cache[6] || (_cache[6] = _createTextVNode(" Est Mode MECEF ? "))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mode de normalisation MECEF ", -1)),
                _createVNode(_component_Field, {
                  as: "select",
                  name: "modeMecef",
                  class: "form-control shadow-none fs-md-15 text-black",
                  modelValue: _ctx.modeMecefSelectionne,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modeMecefSelectionne) = $event))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createElementVNode("option", { value: "API" }, "API (service distant)", -1),
                    _createElementVNode("option", { value: "MACHINE" }, "Machine locale (branchée sur le poste)", -1)
                  ])),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "modeMecef",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Sigle "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "sigle",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le sigle"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "sigle",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Dénomination"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "denomination",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la dénomination"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "denomination",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Raison sociale "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "raisonSocial",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la raison sociale"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "raisonSocial",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" N° RCCM "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "rccm",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le régistre de commerce"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "rccm",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" N° IFU "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "ifu",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'ifu"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "ifu",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Téléphone "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "telephone",
                  modelValue: _ctx.telephone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telephone) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_vue_tel_input, _mergeProps({
                      placeholder: "Entrer le numéro de téléphone",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      defaultCountry: "BJ",
                      mode: "international",
                      onValidate: _ctx.validate,
                      class: "shadow-none fs-md-15 text-black py-2"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (!_ctx.validPhone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Veuillez entrer un numéro correcte"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "telephone",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Email "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "email",
                  type: "email",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'adresse email"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "email",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Adresse "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "adresse",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer l'adresse"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "adresse",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Message Commercial ", -1)),
                _createVNode(_component_Field, {
                  name: "messageCommercial",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer votre message commercial"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "messageCommercial",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Lieu d'impression des factures ", -1)),
                _createVNode(_component_Field, {
                  name: "lieuImpression",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le lieu d'impression"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "lieuImpression",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Joindre le logo ", -1)),
                (_ctx.existingLogoUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (_ctx.isImageFile(_ctx.existingLogoUrl))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.existingLogoUrl,
                            alt: "Logo actuel",
                            style: {"max-height":"60px","max-width":"100px","object-fit":"contain","border":"1px solid #dee2e6","border-radius":"4px","padding":"2px"}
                          }, null, 8, _hoisted_36))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _ctx.existingLogoUrl,
                            target: "_blank"
                          }, _cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "fa fa-file-pdf-o me-1" }, null, -1),
                            _createTextVNode("Voir le fichier actuel ")
                          ]), 8, _hoisted_37)),
                      _cache[20] || (_cache[20] = _createElementVNode("small", { class: "text-muted" }, "(fichier actuel)", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Field, {
                  name: "logo",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Logo"
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "logo",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Joindre l'entête"),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                (_ctx.existingEnteteUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      (_ctx.isImageFile(_ctx.existingEnteteUrl))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.existingEnteteUrl,
                            alt: "Entête actuel",
                            style: {"max-height":"60px","max-width":"100px","object-fit":"contain","border":"1px solid #dee2e6","border-radius":"4px","padding":"2px"}
                          }, null, 8, _hoisted_41))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _ctx.existingEnteteUrl,
                            target: "_blank"
                          }, _cache[22] || (_cache[22] = [
                            _createElementVNode("i", { class: "fa fa-file-pdf-o me-1" }, null, -1),
                            _createTextVNode("Voir le fichier actuel ")
                          ]), 8, _hoisted_42)),
                      _cache[23] || (_cache[23] = _createElementVNode("small", { class: "text-muted" }, "(fichier actuel)", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Field, {
                  name: "entete",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entête"
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "entete",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Joindre le pied de page ", -1)),
                (_ctx.existingPiedUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_ctx.isImageFile(_ctx.existingPiedUrl))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.existingPiedUrl,
                            alt: "Pied de page actuel",
                            style: {"max-height":"60px","max-width":"100px","object-fit":"contain","border":"1px solid #dee2e6","border-radius":"4px","padding":"2px"}
                          }, null, 8, _hoisted_46))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _ctx.existingPiedUrl,
                            target: "_blank"
                          }, _cache[25] || (_cache[25] = [
                            _createElementVNode("i", { class: "fa fa-file-pdf-o me-1" }, null, -1),
                            _createTextVNode("Voir le fichier actuel ")
                          ]), 8, _hoisted_47)),
                      _cache[26] || (_cache[26] = _createElementVNode("small", { class: "text-muted" }, "(fichier actuel)", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Field, {
                  name: "pied",
                  type: "file",
                  accept: "image/jpeg, image/png application/pdf",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Pied de page"
                })
              ]),
              _createVNode(_component_ErrorMessage, {
                name: "pied",
                class: "text-danger"
              })
            ]),
            (_ctx.modeMecefSelectionne === 'API')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Lien API ", -1)),
                      _createVNode(_component_Field, {
                        name: "lienApi",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Lien API"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "lienApi",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " API Nim ", -1)),
                      _createVNode(_component_Field, {
                        name: "apNim",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "API Nim"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "apNim",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " API Token ", -1)),
                      _createVNode(_component_Field, {
                        name: "apiToken",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "API Token"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "apiToken",
                        class: "text-danger"
                      })
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_54, _cache[31] || (_cache[31] = [
                  _createElementVNode("div", { class: "alert alert-info mb-0" }, " La normalisation se fera via la machine MECeF branchée sur ce poste (détection automatique du port série, aucune configuration supplémentaire requise ici). ", -1)
                ]))),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Format impression "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "formatImpression",
                  modelValue: _ctx.formatImpression,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formatImpression) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: ['A4', 'A5', 'A6', 'T1', 'T2'],
                      searchable: true,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Format impression" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "formatImpression",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit",
                  disabled: !_ctx.validPhone
                }, " Modifier une sociéte ", 8, _hoisted_59),
                _createVNode(_component_router_link, {
                  to: "/societes/liste-societes",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}